import { render, staticRenderFns } from "./WorkflowField.vue?vue&type=template&id=590ad0b6"
import script from "./WorkflowField.vue?vue&type=script&lang=js"
export * from "./WorkflowField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports